/* RESPONSIBLE TEAM: team-actions */

import type Workspace from '../objects/workspace';

export function showUnderConstructionBanner(workspace: Workspace): boolean {
  return workspace.isTestWorkspace === true || workspace.isDeveloperWorkspace === true;
}
